import { BnzRdEnvironment } from 'global-types';

export const environment: BnzRdEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://bnz-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://rewards-auth.bnz.co.nz',
  clientId: '456e60f5-36db-4c47-b5ef-45c47316f5fe',
  connection: 'bnz',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://rewards.bnz.co.nz',
  travelEdgeBaseUrl: 'https://rewards-travel.bnz.co.nz',
  brandName: 'Bank of New Zealand',
  shortBrandName: 'BNZ',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 600,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 60,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'bnz.co.nz',
  },
  appId: 'b04a2e81-ba1a-4957-a2d4-0edc787961ab',
  prismicConfig: {
    apiUrl: 'https://ascendaloyalty.prismic.io/api/v2',
    accessToken:
      'MC5ZSFpteHhNQUFDSUFxMERB.fu-_vX3vv73vv73vv70UFu-_vXJQ77-977-977-977-9I--_vU84R--_vR_vv70z77-977-9Ue-_vUNU77-977-9',
  },
  unleashAppName: 'rd-bnz-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
